import React,{useEffect,useState} from 'react'
import { DataGrid } from '@mui/x-data-grid';
import clinicService from '../../../../../services/clinic.service';

function FeedbackTable({clinicid}) {
  const [comments,setComments] = useState([])
  const [pageNo,setPageNo] = useState(0)
  const [pageSize,setPageSize] = useState(5)
  const [rowCount,setRowCount] = useState(10)
  const [paginationModel,setPaginationModel] = useState({
    page:0,
    pageSize:5,
 })
  const columns = [
    {field:"id", headerName:"ID"},
    {field:"patientId", headerName:'Patient Id'},
    {field:"patientUUID",headerName:'UUID',width:'300'},
    {field:"patientName",headerName:'Name',width:'300'},
    {field:"feedback",headerName:'Feedback',
    valueGetter:(params)=>{
      if(params.value === 0){
        return "Negative"
      }
      if(params.value === 1){
        return "Neutral"
      }
      if(params.value === 2){
        return "Positive"
      }
      
    }
  },
   
  ]

  useEffect(()=>{
     getComments(clinicid,paginationModel.page,paginationModel.pageSize)
  },[paginationModel.page,paginationModel.pageSize])

  const getComments = (clinicid,pageNo,pageSize)=>{
      clinicService.getReputationFeedbacks(clinicid,pageNo,pageSize)
      .then(res=>{
        setComments(res.data.content)
        setRowCount(res.data.totalElements)
      })
      .catch(err=>{
        console.log(err)
      })
  }
  return (
    <>
    <h5>Feedbacks</h5>
    <div style={{ width: '100%' }}>
      
      <DataGrid
        rows={comments}
        rowCount={rowCount}
        columns={columns}
        pagination
        paginationModel={paginationModel}
        pageSizeOptions={[5, 10]}
        paginationMode='server'
        onPaginationModelChange={setPaginationModel}


       />
    </div>
    </>

  )
}

export default FeedbackTable